export const settings = {
  selector: '.c-shopping-center-location',
  locationName: '.c-shopping-center-location__location_name',
  locationNameInner: '.c-shopping-center-location__location_name_inner',
  locationNameSingle: '.c-shopping-center-location__location_name_single',
  locationContent: '.c-shopping-center-location__content'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  let firstElement = null
  Array.from( elements ).forEach(( element ) => {
    element.classList.add( 'js-tabs-active' )

    if ( null === firstElement ) {
      firstElement = element
    }

    // add a click handler to the title
    let title = element.querySelector( settings.locationNameSingle )
    title.addEventListener( 'click', ( e ) => {
      let cityId = e.target.dataset.cityid

      // Make the tab focusable via keyboard
      e.target.tabIndex = '0'

      // hide all the cities
      let allCities = document.querySelectorAll( settings.locationContent )
      allCities.forEach(( elem ) => {
        elem.style.display = 'none'
      })

      // show this city
      let thisCityContent = document.querySelector( settings.locationContent + '[data-cityid="' + cityId + '"]' )
      thisCityContent.style.display = 'grid'

      // mark this tab active
      document.querySelectorAll( settings.locationNameSingle ).forEach(( elem ) => {
        elem.classList.remove( 'js-tab-active' )
      })
      e.target.classList.add( 'js-tab-active' )
    })

    // add keyboard support to tabs
    title.addEventListener( 'keyup', ( e ) => {
      if ( e.keyCode === 13 ) {
        title.click()
      }
    })

    if ( firstElement !== element ) {
      // add this locations title to the first element
      firstElement.querySelector( settings.locationNameInner ).appendChild( element.querySelector( settings.locationNameSingle ))

      // hide the wrapper
      element.querySelector( settings.locationName ).style.display = 'none'
    }
  })

  // Activate the first tab by "clicking" it
  if ( elements.length ) {
    document.querySelector( settings.locationNameSingle ).click()
  }
}


